let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6z7Lu")).then(() => parcelRequire('cqWnC'));